import { LoadParamsProps, GetLoadParamsProps } from '../TargetCampaignsProps';

export const getLoadParams = ({ name, search, page, perPage }: GetLoadParamsProps): LoadParamsProps => ({
    name,
    nameLike: search,
    limit: perPage,
    offset: perPage * (page - 1),
});
